import React, { useState } from "react";
import styled from "styled-components";
import { Button, Alert, Modal } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import verifyCodeSchema from "~/forms/VerifyCodeForm/verifyCodeSchema";
import VerifyCodeForm from "~/forms/VerifyCodeForm";
import api from "~/lib/api";
import { useHistory } from "react-router-dom";
import { RoutesEnum } from "~/types/enums";
import { handleError } from "~/lib/helpers";
import authActionCreators from "~/store/auth/actions";
import { useDispatch } from "react-redux";
import Markdown from "~/components/Markdown";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const VerifyCodeModal = _ref => {
  let {
    firstName,
    email,
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const history = useHistory();
  const dispatch = useDispatch();
  const defaultValues = {
    firstName,
    email,
    code: ""
  };
  const {
    handleSubmit,
    control
  } = useForm({
    resolver: yupResolver(verifyCodeSchema),
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    setIsLoading(true);
    api.verifyWorkingStyleCode(data).then(_ref2 => {
      let {
        token
      } = _ref2;
      if (token) {
        dispatch(authActionCreators.updateTokenStarted(token));
        history.push(RoutesEnum.MY_WORKING_STYLE);
      }
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setIsLoading(false);
    });
  });
  const handleClose = () => {
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("VerifyCodeModal.verifyCode"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "420px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Markdown, {
    text: t("VerifyCodeModal.description", {
      email
    }),
    fontSize: 4,
    s: {
      mb: 3
    }
  }), /*#__PURE__*/React.createElement(VerifyCodeForm, {
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    loading: isLoading,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true
  }, t("VerifyCodeModal.sendCode")))));
};
export default VerifyCodeModal;